<template>
  <fieldset>
    <button class="button button--full-width button--primary submit-form-button" :class="{'button--disabled': disabled}" v-on:click.prevent="click">
      <template v-if="!disabled">
          {{ label }}
      </template>

      <template v-if="disabled">
          <div class="submit-form-button__loading-spinner"></div>
      </template>
    </button>
  </fieldset>
</template>

<script>
  export default {
    name: 'submitBookingButton',
    props: [
      'disabled',
      'label'
    ],
    data () {
      return {
        disable: false
      }
    },
    methods: {
      click () {
        if (this.disabled) return false
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// submitBookingButton.vue?300d5820